import { getGridRowHeight } from "../../../other/utils/utils.jsx";

const COLUMN_REGION_OVERRIDES = {
    "plan-resources-name": "locked",
    "client-name": "locked",
    "schedule-task-name": "locked",
    "resources-name": "left"
};

export default Target => class SwivuStateMixin extends Target {
    applyState(state) {
        // This is required to fix region renaming. State could contain information about a region which no longer exist. In which case
        // rendering will break. We need to process state and rename the region manually. This code can be removed when every client
        // which once pinned a column worked with all pages.
        state.columns?.forEach?.(col => {
            // Try to override region from state definition, there is a subset of columns which should be moved to specific regions by default
            if (col.id in COLUMN_REGION_OVERRIDES) {
                col.region = COLUMN_REGION_OVERRIDES[col.id];
            }

            // And perform a sanity check
            if (!this.regions.includes(col.region)) {
                col.region = this.regions[0];
            }
        });

        super.applyState(state);
    }

    // Bug: Upon enabling auto height in any column of the grid, when rows are refreshed max row height is applied to every row including group headers
    // Below function by default does not return anything, if no height is returned then rowHeight is assigned from row's instance
    // Therefore, for only group header records we are returning height
    processRowHeight(record) {
        if (this.reactComponent && record.isGroupHeader) {
            return getGridRowHeight(record);
        }
    }
}
